import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {toggleModal} from '../store/actions/toggleModalActions';
import {addStation, editStation} from '../store/actions/stationsActions';
import './StationDetails.scss';
import ErrorModal from "./_common/ErrorModal";

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    };
};

const StationDetails = props => {
    const { station, closeForm } = props;
    const { t } = useSelector(selector);
    const dispatch = useDispatch();

    useEffect(() => {
        if(station) {
            setName(station.name);
            setChartId(station.chartId);
            setCity(station.city);
            setLat(station.lat);
            setLon(station.lon);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [station]);

    const [name, setName] = useState(station ? station.name : '');
    const [chartId, setChartId] = useState(station ? station.chartId : '');
    const [city, setCity] = useState(station ? station.city : '');
    const [lat, setLat] = useState(station ? station.lat : '');
    const [lon, setLon] = useState(station ? station.lon : '');

    const [formErrors, setFromErrors] = useState('');

    const openDeleteStationModal = () => {
        dispatch(toggleModal(true, 'deleteStation'));
    };

    const saveStation = async () => {
        const stationData = {
            name,
            chartId,
            city,
            lat,
            lon
        };

        let errors = [];

        if (!name) {
            errors.push(t.gettext('Name'));
        }

        if (!chartId) {
            errors.push(t.gettext('Chart Id'));
        }

        if (!city) {
            errors.push(t.gettext('City'));
        }

        if (!lat) {
            errors.push(t.gettext('Latitude'));
        }

        if (!lon) {
            errors.push(t.gettext('Longitude'));
        }

        if(errors.length) {
            const errorFields = errors.join().replace(/,/g, ', ');
            const errorMessage = errorFields + ' ' + (station ? t.gettext('are required on station update') : t.gettext('are required on station creation')) + '.';
            setFromErrors(errorMessage);
        }

        if(station && !errors.length) {
            stationData.id = station.id;
            await dispatch(editStation(stationData));
            closeForm();
        } else if (!errors.length) {
            await dispatch(addStation(stationData));
            closeForm();
        }
    };

    return (
        <div className='StationDetails'>

            <div className='columnHeader'>
                <div className='columnHeaderLeft'>
                    {station ? t.gettext('Meteo station details') : t.gettext('Add meteo station')}
                </div>
                <div className='columnHeaderRight'>
                    <button
                        className='columnHeaderButton'
                        onClick={saveStation}
                    >
                        <span className="material-icons columnHeaderButtonIcon">
                            save
                        </span>
                    </button>
                    {station &&
                        <button
                            className='columnHeaderButton columnHeaderButton--delete'
                            onClick={openDeleteStationModal}
                        >
                            <span className="material-icons columnHeaderButtonIcon">
                                delete
                            </span>
                        </button>
                    }
                    <button
                      className='columnHeaderButton'
                      onClick={closeForm}
                    >
                        <span className="material-icons columnHeaderButtonIcon">
                            cancel
                        </span>
                    </button>
                </div>
            </div>

            <div className='columnItem'>
                <form className='columnItemForm'>
                    <div className='columnItemFormLabel'>
                        {t.gettext('Name')}
                    </div>
                    <input
                        className='columnItemFormInput'
                        type='text'
                        onInput={e => setName(e.target.value)}
                        value={name ? name : ''}
                    />

                    <div className='columnItemFormLabel'>
                        {t.gettext('Chart Id')}
                    </div>
                    <input
                        className='columnItemFormInput'
                        type='text'
                        onInput={e => setChartId(e.target.value)}
                        value={chartId ? chartId : ''}
                    />

                    <div className='columnItemFormLabel'>
                        {t.gettext('City')}
                    </div>
                    <input
                        className='columnItemFormInput'
                        type='text'
                        onInput={e => setCity(e.target.value)}
                        value={city ? city : ''}
                    />

                    <div className='columnItemFormLabel'>
                        {t.gettext('Latitude')}
                    </div>
                    <input
                        className='columnItemFormInput'
                        type='text'
                        onInput={e => setLat(e.target.value)}
                        value={lat ? lat : ''}
                    />

                    <div className='columnItemFormLabel'>
                        {t.gettext('Longitude')}
                    </div>
                    <input
                        className='columnItemFormInput'
                        type='text'
                        onInput={e => setLon(e.target.value)}
                        value={lon ? lon : ''}
                    />

                </form>
            </div>

            {formErrors
                ? <ErrorModal
                    error={formErrors}
                    closeMethod={() => setFromErrors('')}
                />
                : null
            }

        </div>
    );
};

export default StationDetails;
